var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"cart-header"},[_c('div',{staticClass:"cart-header-content"},[_c('router-link',{attrs:{"to":{name: 'Home'}}},[_c('img',{attrs:{"height":"40","width":"173","src":_vm.LogoImage}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }